import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';

interface RoleSwitchLoaderProps {
	isLoading: boolean;
}

export function RoleSwitchLoader({ isLoading }: RoleSwitchLoaderProps) {
	const [show, setShow] = useState(false);

	// Add a slight delay before showing the loader to avoid flashing
	useEffect(() => {
		let timeoutId: NodeJS.Timeout;

		if (isLoading) {
			timeoutId = setTimeout(() => {
				setShow(true);
			}, 100);
		} else {
			setShow(false);
		}

		return () => {
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, [isLoading]);

	if (!show) return null;

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			width="100%"
			height="100%"
			display="flex"
			justifyContent="center"
			alignItems="center"
			bgcolor="rgba(0, 0, 0, 0.7)"
			zIndex={9999}
			sx={{
				backdropFilter: 'blur(2px)',
			}}
		>
			<CircularProgress size={60} style={{ color: '#FFFFFF' }} />
		</Box>
	);
}
